(function() { window.GUID_fb7037b1_ff42_4d1e_9fda_e93669f3587b = { getGuid: function() { return "fb7037b1-ff42-4d1e-9fda-e93669f3587b"; } }; })();
var CS;
(function (CS) {
    class Radio {
        constructor(inputBox) {
            this.SetStyle = function () {
            };
            this.SetEvents = function () {
                var me = this;
                $(this.Radio).off('change');
                $(this.Radio).on('change', function () {
                    me.Radio.trigger("CSChange", me);
                });
            };
            this.Radio = $(inputBox);
            //Protection pour le nouveau helper
            if (this.Radio.hasClass('IHasChanged')) {
                return;
            }
            this.RadioId = this.Radio[0].id;
            this.SetEvents();
        }
    }
    CS.Radio = Radio;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSRadio = function () {
        this.each(function () {
            var radio = new CS.Radio($(this));
            //Donne access au checkbox de n'importe quels scripts.
            if (radio.RadioId != "")
            {
                eval('document.' + radio.RadioId + '=radio;');
            }
        });
    };
})(jQuery);


var CS = CS || {};

CS.Radio = function (inputBox) {

    this.Radio = $(inputBox);
    this.RadioId = this.Radio[0].id;
    this.SetEvents();
};

CS.Radio.prototype = function () {

    var SetStyle = function () {

    },
    SetEvents = function () {
        var me = this;
        
        $(this.Radio).off('change');
        $(this.Radio).on('change', function () {

            me.Radio.trigger("CSChange", me);

        });
    };
    return {
        SetStyle: SetStyle,
        SetEvents: SetEvents
    };

}();
*/ 

//# sourceMappingURL=cs.radio.js.map
